module.exports = (__webpack_require__("dll-reference common"))("./core/passiveEvent.js");